//import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'
const LanguageKey = 'Admin-language'
const RolesKey = 'Admin-roles'
const UserInfo = 'User-Info'
const HeaderUrlKey = 'Admin-headerurl'

export function getToken () {
  return localStorage.getItem(TokenKey);
}

export function setToken (token) {
  return localStorage.setItem(TokenKey, token);
}
 

export function getSessionID () {
  var sessionid = sessionStorage.getItem('sessionRequest')
  if (sessionid === null || sessionid === undefined) {
    sessionid = uuid()
    sessionStorage.setItem('sessionRequest', sessionid)
  }
  return sessionid
}

export function uuid () {
  var s = []
  var hexDigits = '0123456789abcdef'
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = '-'
  var uuid = s.join('')
  return uuid
}

//  设置cookie
export function setCookie(key, value, day) {
  var exdate = new Date() //  获取时间
  exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * day) //  保存的天数
  //  字符串拼接cookie
  window.document.cookie = key + '=' + value + ';path=/;expires=' + exdate.toGMTString()
}

//  读取cookie
export function getCookie(param) {
  var c_param = ''
  if (document.cookie.length > 0) {
    var arr = document.cookie.split('; ')
    for (var i = 0; i < arr.length; i++) {
      var arr2 = arr[i].split('=') //  再次切割
      //  判断查找相对应的值
      if (arr2[0] === param) {
        c_param = arr2[1]
        //  保存到保存数据的地方
      }
    }
    return c_param
  }
}
